import GLOBAL from '@/assets/js/global.js'

let host = GLOBAL.host,
    issn = GLOBAL.issn,
    domain = GLOBAL.domain;

export default {
    login : host + 'api/login/authorize?callbackurl=' + encodeURIComponent(domain) + '&issn=' + issn,
    logout : '',
    free : host + 'api/login/kouDai',
    logininfo : host + 'api/user/getLoginInfo',
    userinfo : host + 'api/recruit/getUserInfo',
    queryplayer : host + 'api/user/getNickName',
    bind : host + 'api/user/bind',
    draw_list : host + 'api/gift/drawList',//获取抽奖列表
    share_config : host + 'api/share/GetConfigs',//获取邀请配置
    share_apply : host + 'api/share/reward',//手动领取分享奖励
    getcode : host + 'api/share/getInviteCode',//获取邀请码
    lottery : host + 'api/gift/draw',//抽奖
    buy : host + 'api/gift/buy',//购买
    record_list : host + 'api/gift/userGiftList?pageIndex=1&pageSize=0',//record
    apply : host + 'api/gift/achieve',//直接领取道具 type=1 //登录领取 type=2 //章节基金礼 一键领取 type=3&giftId=1 //礼包1领取 type=3&giftId=2 //礼包2领取 type=3&giftId=3 //礼包3领取
    unlock : host + 'api/gift/unlock',//599解锁
    friend_list : host + 'api/share/getList',//好友列表
    invite : host + 'api/share/getCode',//获取邀请码
    apply_invite : host + 'api/share/bindCode',//绑定邀请码
    invite_info : host + 'api/share/getNickName',//获取昵称信息
    share_apply : host + 'api/share/reward',//手动领取分享奖励
    task_info : host + 'api/UserTask/GetList',//积分奖励
    task_apply : host + 'api/UserTask/RwTaskId',//领取奖励
    tips : 'https://tool.m3guo.com/api/web/m3goods/eq-item/',//tip获取
    mplat : host + 'api/login/mplat',//梦平台免登录
    queryscore : host + 'api/chicken/queryScore',//军威值查询    
}


// WEBPACK FOOTER //
// ./src/utils/axios/map.js